import React, { Component  } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { ScrollView } from '../../../../common/components/atoms';
import { HeaderTitle } from '../../../components/molecues';

class Content extends Component {
    constructor(props) {
        super(props);
        this.refScroll = React.createRef();
        let contentID = Number(this.props.contentID);
        let current = Number(this.props.current);
        this.state = {
            current: Number(current),
            title: "",
            text: "",
            contentID: Number(contentID),
        }
    }
    componentDidMount() {
        this.contentReload();
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    contentReload = () => {
        this.props.dispatch({
            type: "GetContentList_Saga",
            id: Number(this.state.contentID),
            onSuccess: this.onSuccessGetContentList,
            onFailure: this.onFailure,
        });
        if(Number(this.state.contentID) === 1){
            this.props.dispatch({
                type: "SetWebinarInfoRead_Saga",
                userID: this.props.user.id,
                onSuccess: this.onSuccessSetWebinarInfoRead,
                onFailure: this.onFailure,
            });
        }
    }
    onSuccessSetWebinarInfoRead = () => {
    }
    onSuccessGetContentList = (items) => {
        this.setState({
            title:  items[0].title,
            text: items[0].text,
        });
    }
    onClickHome = () => {
        this.props.history.replace('/home');
    }
    createContents = () => {
        let contentID = this.state.contentID;
        return(
            <ContentGroup>
                <ContentBox>
                    <ContentTitle dangerouslySetInnerHTML={{ __html: this.state.title }} />
                    <ContentText dangerouslySetInnerHTML={{ __html: this.state.text }} />
                </ContentBox>
            </ContentGroup>
        );
    }
    render() {
        const propsHeader = {
            current: this.state.current,
            onClickHome: this.onClickHome,
        };
        const propsScroll = {
            width: '100%',
            height: (window.innerHeight - 64 ) + "px",
            contents: this.createContents()
        };

        return (
            <Body>
                <HeaderTitle {...propsHeader}></HeaderTitle>
                <ScrollView ref={this.refScroll} {...propsScroll} />
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        user: store.login.user,
        loading: store.loading.loading,
        contentID: store.home.contentID,
        current: store.home.current,
    }
};

const connectedContent = connect(mapStateToProps)(Content);
export { connectedContent as Content };

const Body = styled.div`
`;
const ContentGroup = styled.div`
    width: 100%;
    align-items: center;
`;
const ContentBox  = styled.div`
    width:95%;
    align-items: center;
    margin:10px 5px;
`;
const ContentName = styled.div`
    font-weight: bold;
    font-size:15px;
    margin-bottom:10px;
`;
const ContentTitle  = styled.div`
    font-size:15px;
`;
const ContentText = styled.div`
    font-size:14px;
`;